import getPower from '../../api/shop/getPower';
import SelectWithFetch from './SelectWithFetch';

const SelectPower = (props) => {
  return <SelectWithFetch fetch={getPower} label="Л.С." placeholder="Выберите из списка" {...props} />;
};

export default SelectPower;
